/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preparing_Source_Event_GroupInputs */

const en_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing source Event Group for translation`)
};

const fr_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation du groupe d’événements source pour la traduction`)
};

const de_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereitung der Quellereignisgruppe für die Übersetzung`)
};

const it_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione del gruppo di eventi di origine per la traduzione`)
};

const ru_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовка исходной группы событий к переводу.`)
};

const es_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación del grupo de eventos de origen para la traducción`)
};

const zh_cn2_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备源事件组进行翻译`)
};

const ja_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳用のソースイベントグループを準備しています`)
};

const hi_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद के लिए स्रोत इवेंट समूह तैयार करना`)
};

const pt_pt2_preparing_source_event_group = /** @type {(inputs: Preparing_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando o grupo de eventos de origem para tradução.`)
};

/**
* | output |
* | --- |
* | "Preparing source Event Group for translation" |
*
* @param {Preparing_Source_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preparing_source_event_group = /** @type {((inputs?: Preparing_Source_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preparing_Source_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preparing_source_event_group(inputs)
	if (locale === "de") return de_preparing_source_event_group(inputs)
	if (locale === "it") return it_preparing_source_event_group(inputs)
	if (locale === "ru") return ru_preparing_source_event_group(inputs)
	if (locale === "es") return es_preparing_source_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_preparing_source_event_group(inputs)
	if (locale === "ja") return ja_preparing_source_event_group(inputs)
	if (locale === "hi") return hi_preparing_source_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_preparing_source_event_group(inputs)
	return en_preparing_source_event_group(inputs)
});